import { createFileRoute, redirect } from '@tanstack/react-router';

// The agent automations section defaults to the runs view; the individual
// automations list lives at /admin/agent/automations/list.
export const Route = createFileRoute('/_app/admin/agent/automations/')({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: '/admin/agent/automations/runs',
            search: location.search,
            replace: true,
        });
    },
    component: () => null,
});
